$(function(){
  $('.jsc-question-popup-overlay').hide();
  $('.jsc-question-popup').hide();
  $('.jsc-review-content').hide();
  onloadchangereview();
  stickypdpimg();
  onloadshowllswapvariant();
  mobstickypdpimg();
  onloadSegunoBanner();
  onClickreviewStar();
  removeUncompleteSet();
  updateShipDateInCart();
  if (location.href.includes('/collections')) {
  //waitForElement();
  }
});

pageReload = () =>{
 location.reload();
}

closeAlertPop = () =>{
  $('.alert_popup_modal').hide();
  pageReload();
}

updateShipDateInCart = () =>{
  $('._cart-update-shipdate').each(function(){

    var _vid= parseInt($(this).attr('data-vid'));
    var _labeldate = $(this).attr('data-label');
    var _shipdate = $(this).attr('data-date');

    $.getJSON('/cart.js', function(cart) {

      for (var i = 0; i < cart.items.length; i++) {
        var cart_vid = cart.items[i].id;
        var cart_qty = cart.items[i].quantity;
        var cart_shipdate = cart.items[i].properties['Delivers From'];

        var $properties = cart.items[i].properties;

        if (_vid == cart_vid) {
          if (_shipdate != cart_shipdate) {
            $('.alert_popup_modal').show();
            $('.alert_update_content').css('display','block');

            $properties['Label'] = _labeldate;
            $properties['Delivers From'] = _shipdate;

            CartJS.updateItemById(cart.items[i].key,cart_qty,$properties);
            console.log('updating..');
          }
        }
      }

   });
 });
}

removeUncompleteSet = () =>{
  $('.jsc-bundle').each(function(){

    var _bundleid = $(this).data('bundleid');
    var _series = $(this).children().find('.jsc-mainSeries-label')[0];
    var _frame = $(this).children().find('.jsc-tableleg-label')[0];
    var _top = $(this).children().find('.jsc-tabletop-label')[0];

    //series only desks
    var _seriesOnlyDesk = $(this).find('.jsc-series-only-cart')[0];

    // Call cart json
    $.getJSON('/cart.js', function(cart) {
      _cart = cart;

      // Remove item
      for (var i = 0; i < _cart.items.length; i++) {
        if (_seriesOnlyDesk) {
          console.log('dont remove');
        }else {
          if ((cart.items[i].properties['_BindID'] == _bundleid && _series == undefined) || (cart.items[i].properties['_BindID'] == _bundleid && _frame == undefined) || (cart.items[i].properties['_BindID'] == _bundleid && _top == undefined)){
            $('.alert_popup_modal').show();
            $('.alert_oos_content').css('display','block');
            CartJS.updateItemById(cart.items[i].key, 0);
            console.log('remove');
          }
        }
      }

      // $(document).on('cart.requestComplete', function(event, cart) {
      //   location.reload();
      // });
   });
 });
}

clickQsn  = (evt) =>{
  var $this = $(evt);
  var $dataHandle = $this.attr('data-product-handle');
  var $popupContainer = $('.jsc-question-popup-content');
  var $img = $this.attr('data-img');

  $popupContainer.children().remove();
  $('.jsc-question-popup').removeClass('jsc-popup-full');

      jQuery.getJSON('/products/'+$dataHandle+'.js', function(product) {
        $popupContainer.append('<div class="jsc-popup-cell"><div class="jsc-cell-img"><img src="'+$img+'"></div><div class="jsc-cell-content"><div class="jsc-popup-title">'+product.title+'</div><div class="jsc-popup-description">'+product.description+'</div></div></div>');
        $('.jsc-question-popup').show();
        $('.jsc-question-popup-overlay').show();
    } );

}

// clickQuestion  = (evt) =>{
//   var $this = $(evt);
//   var $dataHandle = $this.attr('data-product-handle');
//   var $eachProduct = $dataHandle.split(',');
//   var $popupContainer = $('.jsc-question-popup-content');
//
//   destroypopupflickity();
//
//   $popupContainer.children().remove();
//   $('.jsc-question-popup').removeClass('jsc-popup-full');
//   for(var i = 0; i < ($eachProduct.length - 1); i++)
//   {
//       jQuery.getJSON('/products/'+$eachProduct[i]+'.js', function(product) {
//         $popupContainer.append('<div class="jsc-popup-cell"><div class="jsc-cell-img"><img src="'+product.images[0]+'"></div><div class="jsc-cell-content"><div class="jsc-popup-title">'+product.title+'</div><div class="jsc-popup-description">'+product.description+'</div></div></div>');
//     } );
//     if (i == ($eachProduct.length - 2)) {
//       setTimeout(function(){
//       initpopupflickity();
//     }, 1000);
//     }
//   }
//   $('.jsc-question-popup').show();
//   $('.jsc-question-popup-overlay').show();
// }

initpopupflickity = () =>{
  $('.jsc-question-popup-content').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    adaptiveHeight: true,
    groupCells: false
  });
}

destroypopupflickity = () =>{
  $('.jsc-question-popup-content').flickity();
  $('.jsc-question-popup-content').flickity('destroy');
}

closequestionpopup = () =>{
  $('.jsc-question-popup-overlay').hide();
  $('.jsc-question-popup').hide();
}

togglemenuArrow = (evt) =>{
  var $is_large = false;
  var $is_xl = false;
  var t = $(evt).attr("data-iprod")
  $(evt).siblings('.jsc-arrow-icon').toggleClass( "open-dropdown" )
  var iProd =  $(".addOns");

  // check if type large and XL only
  var $type = $('.type-selected')[0];
  if ($type) {
    $is_large = $('.type-selected').attr('config-hash').includes('straight-edge-large');
    $is_xl = $('.type-selected').attr('config-hash').includes('straight-edge-xl');
  }

  var dataaddon =  $(".finishing-selected").attr('data-addon');

  iProd.each(function(){
    var i = $(this).attr('data-iprod');
    var isDrawer = $(this).hasClass('is_drawer_hidden');
    var dataAddonName = $(this).attr('data-addon');

    if ((t == i) && (!dataaddon) && (dataAddonName)) {
      $(this).find('button').removeClass('addon-selected-active');
      if ($(this).find('.jsc-quantity')) {
        $(this).find('.jsc-quantity').val(0);
      }
    }

    if ((t == i) && (dataaddon) && (dataAddonName) && (dataAddonName.includes(dataaddon))){
      $(this).toggle();
      console.log('include keep drawer');
    }
    else if ((t == i) && (!isDrawer)) {
      $(this).toggle();
      console.log('exclude keep drawer');
    }


  });

  // toggle clear addon
  var clear_ele = $(".jsc_addon_clear");
  clear_ele.each(function(){
    var prodIndex = $(this).attr('data-i');

    if (t == prodIndex) {
      $(this).toggle();
    }
  });
}

removeProduct = (evt) => {
  // NProgress.start();
  var _cart;
  var _bundleid = $(evt).data('bundleid');
  var _Property = {};
  var _mainproductkey = $(evt).attr('data-mainProduct');
  var _datapromo = $(evt).attr('data-bundlePromo');
  var _promoProduct = _datapromo.split(',');

    // Remove promo item
    for(var i = 0; i < (_promoProduct.length - 1); i++)
    {
      console.log(_promoProduct[i]);
      CartJS.updateItemById(_promoProduct[i], 0);
    }

    // Call cart json
    $.getJSON('/cart.js', function(cart) {
      _cart = cart;

      // Remove addon item
      for (var i = 0; i < _cart.items.length; i++) {
        //console.log(cart.items[i].properties['_BindID']);
        if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_Addon'] == 'Yes') {
          CartJS.updateItemById(cart.items[i].key, 0);
        }
        if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_Main Product'] == 'true') {
          CartJS.updateItemById(_mainproductkey, 0);
        }
        if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_Table Top'] == 'true') {
          CartJS.updateItemById(cart.items[i].key, 0);
        }
        if (cart.items[i].properties['_BindID'] == _bundleid && cart.items[i].properties['_Frame'] == 'true') {
          CartJS.updateItemById(cart.items[i].key, 0);
        }
      }
    });


  $('.jsc-bundleitem-minicart').each(function(){
    var productbundleID = $(this).data('bundleid');
    if (productbundleID == _bundleid) {
      $(this).addClass('animated fadeOutLeft');
    }
   });

   $(document).on('cart.requestStarted', function(event, cart) {
     var $html = `<div class="jsc-page-loading">
                   <div class="jsc-spinner-container">
                     <div class="jsc-spinner"></div>
                   </div>
                 </div>`;
     $('body').prepend($html);
   });
   $(document).on('cart.requestComplete', function(event, cart) {
     $('.jsc-page-loading').remove();
     location.reload()

   });
}

removenotProductbundle = (evt) => {
    setTimeout(() => {
      location.reload()
    }, 800);
}

changetabs = (evt, dataTabs) =>{
  var $this = $('.jsc-menu-tabs');

  $this.each(function(){
    var $dataTabs = $(this).attr('data-tabs');

      if ($dataTabs == dataTabs) {
        $(this).addClass('isactive');
      }else {
        $(this).removeClass('isactive');
      }
   });

   if (dataTabs == "description") {
     $('.jsc-review-content').hide();
   }
   if (dataTabs == "reviews") {
     $('.jsc-review-content').show();
   }

}

//start of review tabs content on collection page

var dataProducthandle,
    $reviewProduct = $('.jsc-review-product'),
    $stampedAppendDiv = $('#jsc-append-stamped-review-widget .appendhere');

stampedProductReviewStars = (dataProducthandleValue) => {

    // console.log(dataProducthandleValue + '____________________ Star Rating');
    $reviewProduct.each(function () {
        var $dataHandle = $(this).attr('data-review');
        if ($dataHandle == dataProducthandleValue) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
}


stampedAppend = () => {
    var dataProductid = $('.main-selected-active').attr('data-product-id');
    var datareview = $('.main-selected-active').attr('data-product-review');

    // console.log(dataProductid + "__________________dataProductid");
    console.log(datareview + "__________________datareview");

    $stampedAppendDiv.children().remove();
      $stampedAppendDiv.append('<div id="stamped-main-widget" class="stamped-main-widget" data-widget-style="standard" data-product-id=' + dataProductid+'>'+ datareview + '</div>');

    // setTimeout(function () {
    //     StampedFn.loadWidget(true);
    // }, 3000);
}

function waitForElement(){
    if(typeof StampedFn !== "undefined"){
        StampedFn.loadWidget(true);
    }
    else{
        setTimeout(waitForElement, 1000);
    }
}

stampedReclick = () => {
   var widget = document.querySelector('#stamped-main-widget');
  setTimeout(function(){
    if(widget){
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.href = 'https://cdn1.stamped.io/files/widget.min.css';
      document.head.appendChild(link);
      document.querySelector('#stamped-main-widget').innerHTML = '';
      StampedFn.loadWidget(true);
    }
  },1000);
}

onloadchangereview = () => {
    // console.log('onloadchangereview_________________________');
    dataProducthandle = $('.main-selected-active').attr('data-product-handle');
    stampedProductReviewStars(dataProducthandle);
    stampedAppend();
    console.log(dataProducthandle,' JS dataProducthandleValuew_________________________');

}

changereview = (evt, dataProducthandleValue) => {
    // console.log('changereview_________________________');
    stampedProductReviewStars(dataProducthandleValue);
    stampedAppend();
    console.log(dataProducthandle,'CHANGE JS dataProducthandleValuew_________________________');
}


//end of review tabs content on collection page

scrolltopdpimg = () =>{
  $('html, body').animate({
        scrollTop: 0
    }, 1000);
}

// start sticky img pdp

stickypdpimg = () =>{
if (location.href.includes('/collections')) {
  if ($(window).width() >= 799) {
    var stickyimgwidth = $('.jsc-product-img').width();

  $(window).scroll(function() {
     var stickyimgTop = $('.jsc-tab-wraper').offset().top;
     var totaloffset = stickyimgTop - 820;
     var windowTop = $(window).scrollTop();
// console.log(totaloffset,windowTop);
     if (totaloffset > windowTop) {
       // console.log(stickyimgwidth);
       $('.jsc-product-img').addClass('jsc-product-sticky');
       $('.jsc-product-img').css('width', stickyimgwidth);
       $('.jsc-product-img').css('max-width', 640);
       $('.jsc-product-img').removeClass('jsc-product-absolute');
     } else {
        $('.jsc-product-img').removeClass('jsc-product-sticky');
        $('.jsc-product-img').css('width', stickyimgwidth);
        $('.jsc-product-img').addClass('jsc-product-absolute');
     }
   });
 }
}
}

mobstickypdpimg = () =>{
if (location.href.includes('/collections')) {
  if ($(window).width() < 799) {
    $('.jsc-product-img').addClass('jsc-mob-img-sticky');
    $('.jsc-product-content').addClass('jsc-img-pdp-padding-content');
    $(window).scroll(function() {
         var stickyimgTop = $('.jsc-tab-wraper').offset().top ;
         var totaloffset = stickyimgTop - 60;
         var windowTop = $(window).scrollTop();
         // console.log(stickyimgTop,windowTop);

         if (stickyimgTop > windowTop) {
           $('.jsc-product-img').addClass('jsc-mob-img-sticky');
           $('.jsc-product-img').removeClass('jsc-mob-img-absolute');
           // $('.jsc-product-content').addClass('jsc-img-pdp-padding-content');
           // $('.jsc-product-img').css('min-height', 335);
         }
         else {
           $('.jsc-product-img').removeClass('jsc-mob-img-sticky');
            $('.jsc-product-img').addClass('jsc-mob-img-absolute');
           // $('.jsc-product-content').addClass('jsc-img-pdp-padding-content');
           // $('.jsc-product-img').css('min-height', 335);
         }
     });
 }
}
}

// end sticky img pdp

toggledropdownpromo = () =>{
  $('.jsc-dropdown-list-wrapper').toggle();
  if ($(window).width() < 481) {
    $('.promo-dropdown-overlay').toggle();
  }
}
closedropdownpromo = () =>{
  $('.jsc-dropdown-list-wrapper').hide();
  $('.promo-dropdown-overlay').hide();
}

//show ll point swap variant
showllswapvariant = (evt,varID) =>{
  var _llshowpoint = $('.jsc-ll-show');

  _llshowpoint.each(function(){
    var $datavarID = $(this).attr('data-variant');
    if ($datavarID == varID) {
      $(this).show();
    }else {
      $(this).hide();
    }
   });
}

onloadshowllswapvariant = () =>{
  var _selectVariant = $('.jsc-swatch-radio:checked').attr('data-id');
  var _llshowpoint = $('.jsc-ll-show');

  _llshowpoint.each(function(){
    var $datavarID = $(this).attr('data-variant');
    if ($datavarID == _selectVariant) {
      $(this).show();
    }else {
      $(this).hide();
    }
   });
}
//end show ll point swap variant

onloadSegunoBanner = () =>{
  if ($(window).width() < 799) {
    setTimeout(function(){
    var segunoBanner = $('.__seguno-banner-container');
    segunoBanner.attr('id','seguno-banner');
      setTimeout(function(){
           //$( "#seguno-banner" ).insertAfter( "#jsc-mob-seguno-banner" );
           $( "#jsc-mob-seguno-banner" ).append($('#seguno-banner') );

           if ($('#jsc-mob-seguno-banner').children().length > 0) {
             $('.jsc-mob-seguno-fixed').css('padding-top', '52px');
             $('.jsc-mob-img-sticky').css('top', '134px');
             $('.jsc-header-atc').css('top', '91px');
           }
      },10);
    }, 2000);
  }
}

onClickreviewStar = () =>{

  $('.jsc-header-reviews').find('.jdgm-prev-badge').click(function(){
    var _reviewTab = $('.pf-accordion-wrapper').prev();
    _reviewTab.attr('data-active','true');
  });
}
